<template>
  <div class="pageContent" style="position:absolute;">
    <div class="topShade"></div>
    <div class="FirstTitle" style="background:url('../../../static/search/roomTopBg.png')">
      <mu-appbar style="height:40px;background:url('../../../static/search/roomTopBg.png');">
        <mu-icon
          value="keyboard_arrow_left"
          color="white"
          slot="left"
          v-on:click="goback"
          style="z-index:999"
        />
        <a
          style="margin-right:0.2rem; z-index:999"
          v-bind:href="'tel:'+ hotelInfo.Phone"
          slot="right"
        >
          <mu-icon value="phone" color="white" :size="20"/>
        </a>
        <mu-icon
          style="top:-2px;position:relative; margin-right:0.1rem;  z-index:999 "
          slot="right"
          :value="starValue"
          :color="starColor"
          :size="20"
          @click="collect"
        />
      </mu-appbar>
    </div>
    <div class="slider" style="z-index:0" v-on:click=" goPage2() ">
      <swiper :options="swiperOption1" style="min-height:3.6rem;">
        <swiper-slide v-for="pic in imgList[0]">
          <img :src="pic.Attachmenturl" class="banner-item" alt v-on:click=" goPage2() ">
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>

    <div class="main" v-if="NowPage==1">
      <div class="topBlock whiteBg" style="width:100%">
        <router-link to="/search/hotailDetail" style="width:100%">
          <div class="title" style="width:6.5rem">{{hotelInfo.HotelName}}</div>
          <div style="float:right">
            <img
              src="../../../static/search/rightArr.png"
              style="height:0.23rem; float:right ; position:relative;top:5px"
            >
          </div>
        </router-link>
        <div style="height: 0.35rem; margin:0.1rem 0 ; z-index:0">
          <mu-icon style="float:left;margin-top:0.12rem" value="room" color="#D4D4D4" :size="13"/>
          <div
            style=" width:5.2rem ; font-size:0.22rem ; float:left ; line-height:0.5rem ;
          display: -webkit-box;  -webkit-box-orient: vertical;  -webkit-line-clamp: 1;  overflow: hidden; "
          >
            <!--多行省略-->
            &nbsp;{{hotelInfo.Address}}
          </div>
          <router-link
            class="radius"
            style=" color: #9DCAB1 ; float:right; padding:0.04rem 0.08rem ;  background-color: #ECF7F1;font-size: 0.22rem; "
            to="/search/mapbook"
          >地图和周边</router-link>
        </div>

        <div style="height: 0.75rem;background-color:white"></div>

        <div style="width:100% ; padding-top:0.2rem; border-top:0.01rem solid #f1f1f1 ;">
          <div class="xiaotubiao">
            <!--<img src='../../../static/service/parking.png' class='parking' v-if='hotelInfo.ServiceHasParking == "True"' />
            <img src='../../../static/service/food.png' class='food' v-if='hotelInfo.ServiceHasResBreakfast == "True"' />
            <img src='../../../static/service/wifi.png' class='wifi' v-if='hotelInfo.ServiceNetwork_Wifi == "True"' />
            <img src='../../../static/service/pp.png' class='pp' v-if='hotelInfo.ServiceCommoninvoice == "True"' />
            <img src='../../../static/service/zp3.png' class='zp3' v-if='hotelInfo.ServiceAddedtax3invoice == "True"' />
            <img src='../../../static/service/zp6.png' class='zp6' v-if='hotelInfo.ServiceAddedtax6invoice == "True"' />-->
            <img
              v-for="ser in g_currentInfo.HotelServiceList"
              :src="'../../../static/service/' + serviceIcon(ser.KeyId) + '.png'"
              v-if="serviceIcon(ser.KeyId) != 'other'"
              v-bind:class="serviceIcon(ser.KeyId)"
              style="margin-right:0.1rem"
            >
          </div>

          <div style="float:right ; font-size:0.26rem">
            <span>
              <stars :score="g_currentInfo.CommentScore"/>
            </span>
            
            <span style="display:inline-block;width:0.3rem"></span>
            
            <span style="color:#666">{{g_currentInfo.CommentScore | toFixed}}分</span>
            
            <span style="display:inline-block;width:0.1rem"></span>
            
            <span class="commont" v-on:click="goCommentList">
              <!--<span style="color:#ffa135"> {{g_currentInfo.CommentCount}}</span>-->
              <span style="color:#F47920">{{g_currentInfo.CommentCount}}</span>
              条评论
              <mu-icon
                value="keyboard_arrow_right"
                color="#D4D4D4"
                :size="16"
                style="position:relative;top:4px;"
              />
            </span>
          </div>
        </div>
      </div>

      <!-- 上面标题框，下面预定早餐 -->
      <div
        style=" width:100% ; background-color:white ;  width: 100%;  "
        v-if=" CanBuyBF ||  CanChooseRoom     "
      >
        <div style="height: 0.2rem; background-color:#f1f1f1 ;"></div>
        <div style=" text-align:left ; padding:0.15rem 0; margin-left: 0.5rem ; overflow:hidden; ">
          <div style="height: 0.1rem;"></div>
          <div
            style="  color:#666; font-size:0.24rem ; padding-bottom:0.15rem; border-bottom:0.01rem solid #f1f1f1 ;   "
          >酒店设施详情</div>
          <div style="height: 0.2rem;"></div>
          <div style=" width:0.9rem ; font-size:0.2rem ; float:left " v-if=" CanBuyBF ">
            <img
              src="../../../static/search/HotelList/BreakfastIcon.png"
              style=" width:0.46rem ;margin-left:0.13rem  "
            >
            <div>早餐购</div>
          </div>

          <div style=" width:1rem ; font-size:0.2rem ; float:left " v-if=" CanChooseRoom ">
            <img
              src="../../../static/search/HotelList/ChooseRoomIcon.png"
              style=" width: 0.46rem ;margin-left:0.25rem  "
            >
            <div>自助选房</div>
          </div>

          <!--积分购买 - KB换房-->
          <div
            style="  font-size:0.25rem ; float:right; margin-right:0.6rem "
            v-if="   CanBuyBF  "
            v-on:click="MakeBreakfastOrder()"
          >
            <div
              style=" color:#27ba69;	border:1px solid #27ba69;margin-top: 0.17rem ;line-height:0.4rem ;padding:0 0.12rem  "
            >购买早餐券</div>
          </div>
        </div>
        <div style="height: 0.01rem;"></div>
      </div>

      <div class="paper" :zDepth="1" style="padding:0px;background-color:white">
        <div class="top dateArea">
          <div>
            <small>入住</small>
            <br>
            <div style="width:100%;position:relative;">
              <mu-date-picker
                class="date"
                format="YYYY-MM-DD"
                :fullWidth="true"
                :maxDate="checkinMaxDate"
                :minDate="checkinMinDate"
                v-model="g_searchParam.startDate"
                :underlineShow="false"
                hintTextClass="date"
                inputClass="dpicker"
                @change="checkinDateChange"
              />
              <span class="formatdate">{{checkInDateFormat}}</span>
            </div>

            <div
              v-if="g_searchParam.isZeroRoom"
              style="  ;position:absolute;margin:-1.5rem 0 0 -1rem ; z-index:999999 ; width:2.5rem ; height: 1.1rem"
            >
              <!-- 用来阻挡选择日期，只有在使用凌晨房的时候阻挡 -->
            </div>
          </div>
          <div class="middle">
            住
            <span>{{day}}</span>晚
          </div>
          <div>
            <small>离店</small>
            <br>
            <div style="width:100%;position:relative;">
              <mu-date-picker
                class="date"
                format="YYYY-MM-DD"
                :fullWidth="true"
                :maxDate="checkoutMaxDate"
                :minDate="checkoutMinDate"
                v-model="g_searchParam.endDate"
                :underlineShow="false"
                hintTextClass="date"
                inputClass="dpicker"
                @change="checkoutDateChange"
              />
              <span class="formatdate">{{checkOutDateFormat}}</span>
            </div>
          </div>
        </div>
        <mu-divider/>
        <mu-list>
          <!--读取中的转圈圈-->
          <div v-if="loading2" style="text-align:center;padding: 15vh 0 5rem 0; ">
            <img src="../../../static/LoadingWhite.gif" style=" width:1.2rem ;">
          </div>

          <div v-for="(room,index) in rooms">
            <!-- 健康房  放在最上面 -->
            <mu-list-item
              :class="{'noRoom': room.AvailRooms <= 0,'isChild': false,'firstChild':  false}"
              v-if=" item.IsHealthyRoom "
              v-for="( item,activityIndex) in room.ActivityList"
              @click="openBottom(index,activityIndex , item.BreakFastState )"
            >
              <!--房间类型名称-->
              <!-- <span class="listTitle">{{item.Name}}</span> -->
              <span class="listTitle">{{room.RoomName}} {{room.RoomDescript}} 健康房</span>

              <div style="font-size:0.22rem">
                <span>{{ room.D_BedType }} {{ room.D_WindowDetails }}</span>
                <span v-if="item.OnlyNewCustomer">本店新客专享</span>
                <span v-if="onlyApp(item)">仅APP</span>
              </div>
              <!--小图标-->
              <!--<span class="color" v-if="vocher != 'null' && vocher != null" v-bind:class="getVType(vocher)" v-for="(vocher,index) in ('' + item.Vouchers).split(',')">{{vocher}}0</span>-->
              <!--非活动房的房间介绍-->
              <div v-if="!item.IsChild" style="font-size:0.22rem">{{item.RoomDescript}}</div>
              <span slot="right">
                <span class="money">￥{{ activityPrice(room,item) | fomatFloat}}</span>
                
                <a
                  :class="{'invalid' : room.AvailRooms <= 0 || (hasCheckedIn && item.OnlyNewCustomer )}"
                  v-on:click="goOrder(index,activityIndex , item.BreakFastState)"
                >{{item.AvailRooms | nullOrNot}}</a>
              </span>
            </mu-list-item>

            <!--基本房型-->
            <mu-list-item
              :class="{'noRoom': room.AvailRooms <= 0,'isChild': room.IsChild ,'firstChild': room.IsChild && !room.ChildPosition}"
              @click="openBottom(index,'' ,room.breakfirst)"
            >
              <!--房间类型名称-->
              <span class="listTitle">{{room.RoomName}} {{room.RoomDescript}}</span>
              <!--小图标-->
              <!--<span class="color" v-if="vocher != 'null' && vocher != null" v-bind:class="getVType(vocher)" v-for="(vocher,index) in ('' + room.Vouchers).split(',')">{{vocher}}0</span>-->
              <!--<span v-if='room.RoomReplace != "" && room.RoomReplace != null' class="color isKCoin">兑</span>-->
              <!--20171226 GXX 标签修改  class="mu-item-content"  决定了下面这块的宽度 -->
              <div style=" font-size:0.18rem ; overflow:hidden  ; margin-top:0.08rem ">
                <div
                  style=" margin-bottom:0.05rem ; float:left ;  border: 1px solid #ffa135 ;margin-right:0.05rem "
                  v-for="(vocher,index) in ('' + room.Vouchers).split(',')"
                  v-if="vocher != 'null' && vocher != null"
                >
                  <span style=" color:#ffa135 ;  padding: 0 0.05rem">{{ vocher }}0元代金券</span>
                </div>
                <div
                  style=" margin-bottom:0.05rem ; float:left ; color:#ffa135 ; border: 1px solid #ffa135 ; padding: 0 0.05rem"
                  v-if="room.RoomReplace != '' && room.RoomReplace != null"
                >{{room.RoomReplace}}K币兑</div>
              </div>

              <!--非活动房的房间介绍-->
              <div style="font-size:0.22rem ; width:100% ">
                <!--{{room.RoomDescript}}  -->
                <span>
                  {{ room.D_BedType }}
                  <!--{{ room.D_WindowDetails }} -->
                </span>
                <span v-if=" room.breakfirst==0 ">不含早</span>
                <span v-if=" room.breakfirst==1 ">单早</span>
                <span v-if=" room.breakfirst==2 ">双早</span>
                <span v-if=" room.breakfirst==3 ">三早</span>
              </div>

              <span slot="right">
                <!-- <span class='money'>￥ {{room.LoginMemberCardRate }}</span> -->
                <span class="money">￥{{ markPrice(room.LoginMemberCardRate)}}</span>
                <!-- GXX180510  价格改为后端算好传过来 -->
                <!-- {{ commenPrice(room) | fomatFloat }} -->
                <!--{{room.IsSpecial }}-->
                <a
                  v-on:click="goOrder(index, '', room.breakfirst )"
                >{{room.AvailRooms | nullOrNot }}</a>
              </span>
            </mu-list-item>

            <!--    下面是活动房型     -->
            <!--<mu-list-item :class="{'noRoom': item.AvailRooms <= 0,'isChild': true,'firstChild':  !item.ChldPosition}" -->
            <mu-list-item
              :class="{'noRoom': room.AvailRooms <= 0,'isChild': true,'firstChild':  activityIndex == 0}"
              v-if=" !item.IsHealthyRoom "
              v-for="( item,activityIndex) in room.ActivityList"
              @click="openBottom(index,activityIndex , item.BreakFastState )"
            >
              <!--房间类型名称-->
              <span class="listTitle">{{item.Name}}</span>
              <!--<div style="float:right ; color:#999 ;font-size:0.22rem ; margin-right:0.4rem ">-->
              <div class="activityRemark">
                <span v-if=" item.BreakFastState==0 ">不含早</span>
                <span v-if=" item.BreakFastState ==1 ">单早</span>
                <span v-if=" item.BreakFastState ==2 ">双早</span>
                <span v-if=" item.BreakFastState ==3 ">三早</span>
                
                <span v-if="item.OnlyNewCustomer">本店新客专享</span>
                <span v-if="onlyApp(item)">仅APP</span>
              </div>
              <!--小图标-->
              <!--<span class="color" v-if="vocher != 'null' && vocher != null" v-bind:class="getVType(vocher)" v-for="(vocher,index) in ('' + item.Vouchers).split(',')">{{vocher}}0</span>-->
              <!--     -->
              <div v-if="!item.IsChild" style="font-size:0.22rem">{{item.RoomDescript}}</div>
              <span slot="right">
                <!--未登录状态-->
                <!--<span v-if="BreakfastInfoList == null" v-bind:class="{ orange: item.breakfirst }">{{item.breakfirst | bfOrNot}}</span>-->
                <!--"正价（各类客源正常折扣价,含代金券预订）"
                          1  "99.8房（贝壳69元房）"    C0000045   贝壳69  C0000001  998  
                          2  "普通特惠房"    特惠  C0000XX  除了贝壳和998
                          3  "连住特惠房"    连住  D000000XXX
                          4  "K币换房"
                5  "K免房券预订"-->
                <span class="money">￥{{ activityPrice(room,item) | fomatFloat}}</span>
                <!--<span class='money'>￥{{ formatAmount(item) | toZero }}</span>-->
                <!--{{room.IsSpecial }}-->
                <a
                  :class="{'invalid' : item.AvailRooms <= 0 || (hasCheckedIn && item.OnlyNewCustomer )}"
                  v-on:click="goOrder(index,activityIndex , item.BreakFastState)"
                >{{item.AvailRooms | nullOrNot}}</a>
              </span>
            </mu-list-item>
          </div>
        </mu-list>
      </div>
    </div>

    <!--下方显示栏-->
    <mu-popup :overlayOpacity="0.7" position="bottom" :open="bottomPopup" @close="close('bottom')">
      <mu-content-block>
        <div class="roomDetail">
          <div class="title" style="padding-bottom:0.2rem;font-weight:bold">
            <span v-if="currentActivity == null" style>{{current.RoomName}}</span>
            <span v-else>{{currentActivity.Name}}</span>
            <mu-icon
              value="close"
              color="#E7E7E7"
              :size="16"
              style="float:right"
              @click="close('bottom')"
            />
          </div>
          <mu-divider/>
          <div v-if="currentActivity == null" style="padding:0.2rem 0;">
            <div style=" color:#ff8f3b; font-size:0.22rem;">会员价</div>
            <span
              v-if="currentActivity == null"
              class="cardsPay"
              style="color:#333; font-size:0.22rem;"
            >
              <span class="card">数字卡￥{{current.DigitalCardRate}}</span>
              <span class="card">贵宾卡￥{{current.VipCardRate}}</span>
              <span class="card">金卡￥{{current.GoldCardRate}}</span>
              <span class="card">铂金卡￥{{current.PlatinumCardRate}}</span>
              <span class="card">贝壳卡￥{{current.ShellCardRate}}</span>
            </span>
            <!--<div v-else>【特惠房不与其他优惠叠加】</div>-->
          </div>
          <div v-if="currentActivity == null" style="padding:0rem 0 0.2rem 0;">
            <div style=" color:#ff8f3b; font-size:0.22rem;">入住房费赚K币等价折扣</div>
            <span
              class="cardsPay"
              style="color:#333; font-size:0.22rem;"
            >数字卡1% 贵宾卡2% 金卡2.5% 铂金卡3% 贝壳卡12%</span>
          </div>

          <mu-divider/>
          <div class="attrs">
            <li>
              <label>面积：</label>
              {{current.D_RoomArea}}㎡
            </li>
            <li v-if="current.D_WindowNum > 0">
              <label>窗户：</label>
              {{current.D_WindowNum}}间{{current.D_WindowDetails}}
            </li>
            <li v-else>
              <label>窗户：</label>
              {{current.D_NoWindownNum}}间无窗
            </li>
            <li>
              <label>床型：</label>
              {{current.D_BedType}}
            </li>
            <li>
              <label>楼层：</label>
              {{current.D_RoomLayer}}层
            </li>
            <!-- <li>
              <label>早餐：</label>{{current.breakfirst | bfOrNot}}
            </li>-->
            <li v-if="currentActivity == null">
              <label>其他：</label>
              {{current.D_RoomShortcoming | remark }}
            </li>
            <li v-else>
              <label>其他：</label>
              {{currentActivity.Description | remark }}
            </li>
            <!-- 健康物料 -->
            <li v-if="currentActivity != null && currentActivity.IsHealthyRoom">
              <label>健康物料：</label>
              {{current.D_HealthyRoomInfo | remark }}
            </li>
          </div>
          <div class="tabBottom">
            <div class="left">
              <span class="price">
                <!-- ￥{{currentLowestPrice | fomatFloat}} -->
                ￥{{currentLowestPrice | fomatFloat}}
              </span>&nbsp;起&nbsp;&nbsp;
              <span class="del">门市价：￥{{currentMarketPrice | fomatFloat}}</span>
              <br>
            </div>
            <div class="right">
              <a
                v-if="currentActivity != null "
                @click="goOrder()"
                :class="{'invalid' : currentActivity.AvailRooms <= 0 || ( currentActivity != null &&hasCheckedIn && currentActivity.OnlyNewCustomer )}"
              >{{currentActivity.AvailRooms | nullOrNot}}</a>
              <a
                v-else
                @click="goOrder()"
                :class="{'invalid' : current.AvailRooms <= 0 || ( currentActivity != null &&hasCheckedIn && currentActivity.OnlyNewCustomer )}"
              >{{current.AvailRooms | nullOrNot}}</a>
            </div>
          </div>
        </div>
      </mu-content-block>
    </mu-popup>

    <!--查看图片-->
    <div id="bg_show" v-if="NowPage>1" style="opacity:1; background-color:black; position:absolute">
      <div style=" right:5% ; padding-top:0.5rem;position:fixed  " v-on:click="CloseLook()">
        <img src="../../../static/service/Close.png" style=" width:0.55rem ;">
      </div>
      <div
        style=" left:8% ; padding-top:0.6rem;position:fixed  "
        v-on:click="goPage2()"
        v-if="NowPage==3"
      >
        <img src="../../../static/service/Back.png" style=" width:0.25rem ;">
      </div>

      <div
        v-if="NowPage==2"
        style="text-align:left ; width:95% ; padding-left:5%; font-size:0.28rem "
      >
        <div style="color:white; height: 1.5rem"></div>

        <div
          style="background-color:#27ba69; height: 0.3rem ;width:0.08rem ; float:left;margin-top:0.06rem "
        ></div>
        <div style="color:white;   width:100% ;margin-left:0.25rem ; ">外观与周边</div>
        <span v-for="  (pic,index)  in imgList[1]" style="  ">
          <img
            :src="pic.Attachmenturl"
            style="width:50%;padding:2%;"
            v-on:click=" goPage3('外观与周边' , index) "
          >
        </span>

        <div style="color:white;   width:100% ;margin-bottom:0.25rem ; "></div>
        <div
          style="background-color:#27ba69; height: 0.3rem ;width:0.08rem ; float:left;margin-top:0.06rem "
        ></div>
        <div style="color:white;   width:100% ;margin-left:0.25rem ; ">公共设施</div>
        <span v-for="  (pic,index)  in imgList[2]" style="  ">
          <img
            :src="pic.Attachmenturl"
            style="width:50%;padding:2%;"
            v-on:click="  goPage3('公共设施' , index ) "
          >
        </span>

        <div style="color:white;   width:100% ;margin-bottom:0.25rem ; "></div>
        <div
          style="background-color:#27ba69; height: 0.3rem ;width:0.08rem ; float:left;margin-top:0.06rem "
        ></div>
        <div style="color:white;   width:100% ;margin-left:0.25rem ; ">客房</div>
        <span v-for="  (pic,index)  in imgList[3]">
          <!--{{pic.IsLogImage}}-->
          <img
            :src="pic.Attachmenturl"
            style="width:50%;padding:2%;"
            v-on:click="  goPage3('客房' , index ) "
          >
        </span>

        <div style="color:white;   width:100% ;margin-bottom:0.25rem ; "></div>
        <div
          style="background-color:#27ba69; height: 0.3rem ;width:0.08rem ; float:left;margin-top:0.06rem "
        ></div>
        <div style="color:white;   width:100% ;margin-left:0.25rem ; ">早餐</div>
        <span v-for="  (pic,index)  in imgList[4]" style="  ">
          <img
            :src="pic.Attachmenturl"
            style="width:50%;padding:2%;"
            v-on:click="  goPage3('早餐' , index ) "
          >
        </span>

        <div style="color:white; height: 2.5rem"></div>
      </div>

      <div v-if="NowPage==3" style="opacity:1 ; text-align:left ;  font-size:0.28rem ">
        <div style=" height: 1.8rem"></div>
        <div style=" font-size:0.32rem ; color:#fff ; text-align:center">{{ NowPicName }}</div>
        <div style=" height: 1.1rem"></div>

        <swiper :options="swiperOption2">
          <swiper-slide v-for="pic in TmpPicList" style="padding-bottom:1rem">
            <img :src="pic.Attachmenturl" style="width:100%;">
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>

        <div style="color:white; height: 2.5rem"></div>
      </div>
    </div>

    <mu-toast v-if="toast" id="alertline" v-bind:message="hintMes" @close="hideToast"/>

    <mu-dialog actionsContainerClass="appActions" :open="appDialog" @close="appDialog=false">
      <div class="appDialog">本房型仅限首次预订用户在格林豪泰APP上预订！
        <div class="img">
          <img src="../../../static/app.png">
        </div>
        <div class="tail">长按图片识别二维码下载app</div>
      </div>
    </mu-dialog>

    <!--弹出框 选择是否-->
    <pop
      :display="popDisplay"
      @closeHandler="closePop"
      @okHandler="closeYES"
      title="提示"
      :msg="popMsg"
      :onlyOk="popOnlyOk"
    />
  </div>
</template>

<style >
</style>


<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { mapGetters } from "vuex";
import { mapMutations } from "vuex";
import date from "../../utils/dateextend.js";
import api from "../../api";
import stars from "../../components/stars";
import service from "../../utils/hotelService.js";

export default {
  data() {
    return {
      swiperOption1: {
        pagination: ".swiper-pagination",
        // loop: true,
        paginationClickable: true,
        autoplay: 5000
      },
      swiperOption2: {
        pagination: ".swiper-pagination",
        // loop: true,
        paginationType: "fraction"
      },
      bottomPopup: false,
      starColor: "white",
      starValue: "star_outline",
      //酒店收藏状态
      collectState: false,
      hintMes: "",
      toast: false,
      hotelInfo: {},
      rooms: [],
      cards: "",
      //选中酒店
      current: "",
      //选中活动
      currentActivity: "",
      // hotelCode: '',
      loading2: false,
      change: false,
      // 折扣最低的卡(除了翡翠、员工、)
      lowestDiscount: "1",
      // 登录状态
      loginState: false,
      NowPage: 1,
      NowPicNo: -1,
      // 早餐信息 -  。  0：不送早，1：送单早，2：送双早
      BreakfastInfoList: "",
      BreakInfo: ["不送早", "送单早", "送双早"],
      // 保留原来的酒店编号
      LastHotelCode: "",
      appDialog: false,
      //用户原来住过
      hasCheckedIn: true,
      //酒店图片列表
      imgList: [],

      // 能不能购买早餐， 能不能自助选房（后端2有1即可）
      CanBuyBF: false,
      CanChooseRoom: false,

      popDisplay: false,
      popOnlyOk: false,
      popMsg: "需要先登陆，是否前往登陆？"
    };
  },
  components: {
    swiper,
    swiperSlide,
    stars
  },

  activated() {
    // 检查时间
    this.checkDateOut();
    // 从缓存判断登录状态
    this.loginState = false;
    if (this.g_UserInfo.Card_no && this.g_UserInfo.Card_no != "") {
      this.loginState = true;
      // this.getRoomList();
    }
    // 尝试获取外挂的参数
    if (this.$route.query.hotelcode != undefined) {
      var model = this.g_currentInfo;
      model.HotelCode = this.$route.query.hotelcode;
      this.setG_currentInfo(model);
    }

    // 缓存信息和当前查询的酒店不同
    if (
      this.LastHotelCode == "" ||
      this.LastHotelCode != this.g_currentInfo.HotelCode
    ) {
      this.GetServiceListByHotelCode();
      this.LastHotelCode = this.g_currentInfo.HotelCode;
      this.hotelInfo = {
        Address: "读取中..",
        HotelName: "读取中..",
        ServiceCommoninvoice: "True",
        ServiceHasParking: "True",
        ServiceHasResBreakfast: "True",
        ServiceNetwork_Wifi: "True",
        CommentScore: 5,
        CommentCount: 0,
        Phone: ""
      };
      //清空收藏状态
      this.starValue = "star_outline";
      this.starColor = "white";
      this.gethoteldetal();
      this.getHotelImgs();
      this.getRoomList();
    } else if (this.TmpUser != this.g_UserInfo.Card_no) {
      this.TmpUser = this.g_UserInfo.Card_no;
      // 重新获取下面的房型列表
      this.getRoomList();
    }

     //获取登录状态
    var params = new this.URLSearchParam();
    params.append('cardNo', this.g_UserInfo ? this.g_UserInfo.Card_no : '')
    this.$http.post(api.loginState(), params.toParam()).then((res) => {     
      if (res.Result) {
        this.loginState = true
      }
      else {
        this.CheckLogin(); 
      }
    })  

  },

  filters: {
    nullOrNot(number) {
      if (number <= 0) {
        return "满房";
      }
      return "预订";
    },
    bfOrNot(hasBf) {
      if (hasBf != "0") {
        return "含早";
      }
      return "无早";
    }
  },
  methods: {
    ...mapMutations({
      setG_searchParam: "setG_searchParam",
      setG_currentInfo: "setG_currentInfo",
      setRoom: "setG_currentRoom",
      setDiscount: "setG_currentDiscount",
      setG_UserInfo:"setG_UserInfo"
    }),

    // pop
    closePop() {
      this.popDisplay = false;
    },
    closeYES() {
      this.popDisplay = false;
      this.$router.push({ path: "/user/login" });
    },

    goback() {
      //  javascript: history.go(-1);
      this.$router.go(-1);
    },

    // 获取房型信息
    GetServiceListByHotelCode() {
      this.CanBuyBF = false;
      this.CanChooseRoom = false;

      var params = new this.URLSearchParam();
      params.append("hotelCode", this.g_currentInfo.HotelCode);
      params.append("CardKind", this.g_UserInfo.Card_kind);

      this.$http
        .post(api.GetServiceListByHotelCode(), params.toParam())
        .then(res => {
          if (res.Result) {
            this.CanBuyBF = res.Data.CanBuyBF;
            // this.BfPrice = res.Data.BfPrice.InfoValueCH
            this.CanChooseRoom = res.Data.CanChoose;
          }
        });
    },

    MakeBreakfastOrder() {
      if (this.loginState)
        this.$router.push({ path: "/search/makeBreakfastOrder" });
      else {
        // this.showToast('登陆后才能购买哦！');
        // setTimeout(() => { this.$router.push({ path: '/user/login' }); }, 2500)

        this.popDisplay = true;
        this.popMsg = "登录后才能购买哦！是否前往登录页？";
      }
    },

    // 查看图片功能
    goPage2() {
      this.NowPage = 2;
    },
    goPage3(name, index) {
      if (name == "外观与周边") this.TmpPicList = this.imgList[1];
      else if (name == "公共设施") this.TmpPicList = this.imgList[2];
      else if (name == "客房") this.TmpPicList = this.imgList[3];
      else if (name == "早餐") this.TmpPicList = this.imgList[4];

      this.NowPicName = name;
      (this.swiperOption2.initialSlide = index), (this.NowPage = 3);
    },

    CloseLook() {
      this.NowPage = 1;
    },
    // 查看图片功能 END

    // 获取房型信息
    gethoteldetal() {
      var params = new this.URLSearchParam();
      params.append("hotelCode", this.g_currentInfo.HotelCode);
      params.append("startDate", this.g_searchParam.startDate);
      params.append("endDate", this.g_searchParam.endDate);
      // params.append("simpleMode", true);
      this.$http.post(api.getHotelDetail(), params.toParam()).then(res => {
        if (res.Result) {
          this.hotelInfo = res.Data;
          if (this.hotelInfo.Phone == "") {
            this.hotelInfo.Phone = "021-36174886";
            //console.log(this.hotelInfo.Phone);
          }

  
          // 这边是名字啊什么的
          this.setG_currentInfo(res.Data);
          if (this.loginState) {
            //获取收藏状态
            this.checkHotel();
          }
        }
      });
    },

    //获取酒店图片
    getHotelImgs() {
      var params = new this.URLSearchParam();
      params.append("hotelCode", this.g_currentInfo.HotelCode);
      this.$http.post(api.getHotelImgs(), params.toParam()).then(res => {
        if (res.Result) {
          this.imgList = res.Data;
          console.log(res.Data);
        }
      });
    },
    addHotel() {
      //收藏酒店
      var params = new this.URLSearchParam();
      params.append("hotelCode", this.g_currentInfo.HotelCode);
      this.$http.post(api.addMyHotel(), params.toParam()).then(res => {
        if (res.Result) {
          this.hintMes = res.Data;
          this.starValue = "star";
          this.starColor = "#FFB03B";
          this.collectState = true;
        } else {
          this.hintMes = res.Message;
        }
        this.showToast();
      });
    },
    deleteHotel() {
      //取消已收藏酒店
      var params = new this.URLSearchParam();
      params.append("hotelCode", this.g_currentInfo.HotelCode);
      this.$http.post(api.DeleteMyHotel(), params.toParam()).then(res => {
        if (res.Result) {
          this.hintMes = res.Data;
          this.starValue = "star_outline";
          this.starColor = "white";
          this.collectState = false;
        } else {
          this.hintMes = res.Message;
        }
        this.showToast();
      });
    },
    checkHotel() {
      // 判断该酒店是否已收藏
      this.$http.post(api.getMyHotel()).then(res => {
        if (res.Result) {
          for (let hotel of res.Data) {
            if (this.g_currentInfo.HotelCode == hotel.HotelCode) {
              this.starValue = "star";
              this.starColor = "#FFB03B";
              this.collectState = true;
              return;
            }
          }
          this.collectState = false;
        } else {
        }
      });
    },

    // 房间列表信息
    getRoomList() {
      this.loading2 = true;

      this.rooms = [];

      var params = new this.URLSearchParam();
      var dateIn = this.g_searchParam.startDate;
      var dateOut = this.g_searchParam.endDate;
      params.append("hotelCode", this.g_currentInfo.HotelCode);
      params.append("startDate", dateIn);
      params.append("endDate", dateOut);
      this.$http.post(api.getRoomTypeList(), params.toParam()).then(res => {
        if (res.Result) {
          this.loading2 = false;
          // 0：不送早，1：送单早，2：送双早
          if (res.Data[2] == null) {
            this.BreakfastInfoList = null;
          } else {
            this.BreakfastInfoList = res.Data[2];
          }

          this.RoomDescription = res.Data[2];

          this.rooms = res.Data[0];
          this.cards = res.Data[1];

          for (var index in this.cards) {
            var card = this.cards[index];
            if (card.ic_kindname == "翡翠卡" || card.ic_kindname == "员工卡") {
              continue;
            }
            if (card.ic_kindzk < this.lowestDiscount) {
              this.lowestDiscount = card.ic_kindzk;
            }
          }
          if (this.loginState) {
            //获取上次签入时间
            this.getMemberLastCheckInDate();
          }
        } else {
        }
      });
    },
    getVType: input => {
      return "is" + input + "0";
    },
    collect() {
      if (this.loginState) {
        if (!this.collectState) {
          this.addHotel();
        } else {
          this.deleteHotel();
        }
      } else {
        this.starValue = "star_outline";
        this.starColor = "white";
        this.showToast("登录后才能收藏哦！");
        setTimeout(() => {
          this.$router.push({ path: "/user/login" });
        }, 2500);
      }
    },
    openBottom(index, activeIndex, breakfastCode) {
      console.log("---------------");

      this.current = this.rooms[index];
      console.log(this.current);
      var params = new this.URLSearchParam();
      params.append("HotelCode", this.current.HotelCode);
      params.append("RoomTypeId", this.current.RoomTypeId);
      params.append("IsSpecial", this.current.IsSpecial);
      params.append("CheckInDate",  this.g_searchParam.startDate);
      console.log(params);
      this.$http.post(api.GetRoomTypeDetailList(), params.toParam()).then(res => {
      if (res.Result) {
         console.log(res.Data);
            this.current.D_RoomArea=res.Data.D_RoomArea;
            this.current.D_BedType=res.Data.D_BedType;
            this.current.D_HealthyRoomInfo=res.Data.D_HealthyRoomInfo;
            this.current.D_NoWindownNum=res.Data.D_NoWindownNum;
            this.current.D_RoomLayer=res.Data.D_RoomLayer;
            this.current.D_RoomShortcoming=res.Data.D_RoomShortcoming;
            this.current.D_WindowDetails=res.Data.D_WindowDetails;
            this.current.D_WindowNum=res.Data.D_WindowNum;
         }
       });
      
      this.currentActivity = null;

      this.breakfastCode = breakfastCode;

      if (activeIndex || activeIndex == "0") {
        this.currentActivity = this.current.ActivityList[activeIndex];
      }
      this["bottomPopup"] = true;
    },
    close(position) {
      this["bottomPopup"] = false;
    },
    showToast(word) {
      this.toast = true;
      if (word) {
        this.hintMes = word;
      }
      if (this.toastTimer) clearTimeout(this.toastTimer);
      this.toastTimer = setTimeout(() => {
        this.toast = false;
      }, 2000);
    },
    hideToast() {
      this.toast = false;
      if (this.toastTimer) clearTimeout(this.toastTimer);
    },
    onlyApp(activity) {
      if (activity.SupportSource == "手机APP,") {
        return true;
      } else {
        return false;
      }
    },
    goOrder(index, activeIndex, breakfastCode) {
      //阻止父事件
      var e = window.event || arguments.callee.caller.arguments[0];
      e.stopPropagation();
      var activity = null;
      var room = null;
      var roomInfo = {};
      var startDate = new Date(this.g_searchParam.startDate).Format(
        "yyyy-MM-dd"
      );

      if (typeof index !== "undefined") {
        room = this.rooms[index];
        if (typeof activeIndex !== "undefined") {
          activity = room.ActivityList[activeIndex];
        }
        roomInfo.breakfastCode = breakfastCode;
      } else {
        //没传index
        room = this.current;
        activity = this.currentActivity;
        roomInfo.breakfastCode = this.breakfastCode;
      }

      if (activity != null && activity.AvailRooms <= 0) {
        return;
      } else if (room.AvailRooms <= 0) {
        return;
      }

      roomInfo.RoomTypeId = room.RoomTypeId;
      roomInfo.AvailRooms = room.AvailRooms;
        //未登录
        console.log(this.loginState);
        if (!this.loginState) {
          this.popDisplay = true;
          this.popMsg = "预订请先登录!是否前往登录页？";
          return;
        }

      //活动房
      if (activity != null) {
        roomInfo.IsSp = true;
        roomInfo.ActivityCode = activity.ActivityCode;
        roomInfo.ActivityType = activity.ActivityType;
        roomInfo.RoomName = activity.Name;
        roomInfo.TotalDays = activity.TotalDays;
        roomInfo.IsOneRoomNight = activity.IsOneRoomNight;
        // 送单早双早，传过去
        //App专享
        //if(activity.SupportSource == "手机APP"){
        if (this.onlyApp(activity)) {
          this.appDialog = true;
          return;
        }
        //未登录
        // if (!this.loginState) {
        //   this.popDisplay = true;
        //   this.popMsg = "非会员不支持活动房型预订!是否前往登录页？";
        //   return;
        // }
        //新客限制
        if (this.hasCheckedIn && activity.OnlyNewCustomer) {
          this.showToast("该房型仅本店新客可享！");
          return;
        }

        //998和69提前
        if (
          activity.ActivityCode == "C0000075" ||
          activity.ActivityCode == "C0000001" ||
          activity.ActivityCode == "C0000187"
        ) {
          if (new Date().Format("YYYY-MM-dd") == startDate) {
            this.showToast(activity.Name + "需要提前一天预订！");
            return;
          } else if (
            date.daysBetween(new Date().Format("YYYY-MM-dd"), startDate) >= 7
          ) {
            this.showToast(activity.Name + "只支持7天内预订！");
            return;
          }
        }
      } else {
        roomInfo.IsSp = false;
        roomInfo.ActivityCode = "";
        roomInfo.TotalDays = room.TotalDays;
        if (room.RoomDescript !== "" && room.RoomDescript !== null) {
          roomInfo.RoomName = room.RoomName + "(" + room.RoomDescript + ")";
        } else {
          roomInfo.RoomName = room.RoomName;
        }
      }
      roomInfo.HotelCode = room.HotelCode;
      this.setRoom(roomInfo);
      this.setDiscount(this.cards);
      this.close();
      //console.log(room.LoginMemberCardRate); //获取房型的价格传到下订单界面
      this.sun = room.LoginMemberCardRate;
      //console.log("测试支付价格++++++++"+ this.sun);
      if (room.HotelCode == "002587") {
        window.location.href =
          "https://res.windsurfercrs.com/ibe/index.aspx?propertyID=15376&nono=1";
      } else if (room.HotelCode == "002846") {
        window.location.href =
          "https://res.windsurfercrs.com/ibe/index.aspx?propertyID=15373&nono=1";
      } else if (room.HotelCode == "003117") {
        window.location.href =
          "https://res.windsurfercrs.com/ibe/index.aspx?propertyID=15378&nono=1";
      } else if (room.HotelCode == "003118") {
        window.location.href =
          "https://res.windsurfercrs.com/ibe/index.aspx?propertyID=15371&nono=1";
      } else if (room.HotelCode == "003119") {
        window.location.href =
          "https://res.windsurfercrs.com/ibe/index.aspx?propertyID=15380&nono=1";
      } else if (room.HotelCode == "003341") {
        window.location.href =
          "https://res.windsurfercrs.com/ibe/index.aspx?propertyID=15390&nono=1";
      } else if (room.HotelCode == "003342") {
        window.location.href =
          "https://res.windsurfercrs.com/ibe/index.aspx?propertyID=15383&nono=1";
      } else if (room.HotelCode == "003343") {
        window.location.href =
          "https://res.windsurfercrs.com/ibe/index.aspx?propertyID=15387&nono=1";
      } else {
        this.$router.push({ path: "/search/makeOrder" });
      }
    },
    goCommentList() {
      this.$router.push({ path: "/hotel/CommentList" });
    },
    //初始化日期
    initDate() {
      var nowDate = new Date();
      var inDate = nowDate.Format("yyyy-MM-dd"); //入住日期为当天
      var outDate = nowDate.DateAdd("d", 1).Format("yyyy-MM-dd"); //离店日期为明天
      this.reWriteQueryDate(inDate, outDate);
    },
    
   // 检验是否登入，APP 小程序 跳转到该页面需要检索到自动登入 功能
    CheckLogin(){
     if (this.$route.query.cardNo!=undefined && this.$route.query.sign!=undefined) {
      var params = new this.URLSearchParam();
      params.append("userId", this.$route.query.cardNo);
      params.append("sign", this.$route.query.sign);
 
      this.$http.post(api.CheckLoginState(), params.toParam()).then(data => {
        if(data.Result){ 
             // 自动登入成功--保存登录信息
             this.loginState=true;
            console.log("========测试========")
            console.log(this.loginState)
        
            var result = data.Data
            this.SaveUserInfo(result)
          }
        });
        }
    },

    
   SaveUserInfo(result) {
      // 保存登录信息
      console.log("-------------")
      var UserInfo = result
      console.log(result);
      if (UserInfo.Card_Kind_Diplay == '网上数字卡') {
        UserInfo.Card_Kind_Diplay = '数字卡'
      }

      UserInfo.OrderRefresh1 = true
      UserInfo.OrderRefresh2 = true
      UserInfo.OrderRefresh3 = true
      // 保存登录信息
      this.setG_UserInfo(UserInfo)
    },

    //检查时间是否超时（入住时间小于今天）
    checkDateOut() {
      if (this.g_searchParam.startDate == "") {
        this.initDate();
      } else {
        var day = date.daysBetween(
          new Date().Format("yyyy-MM-dd"),
          this.g_searchParam.startDate
        );
        if (day < 0) {
          this.initDate();
        }
      }
    },
    checkinDateChange(val) {
      //修改入住时间后离店时间也修改
      this.reWriteQueryDate(
        val,
        new Date(val).DateAdd("d", 1).Format("yyyy-MM-dd")
      );
    },
    checkoutDateChange(val) {
      //修改离店时间时只要修改离店时间，因为离店时间不可能小于入店时间
      this.reWriteQueryDate(this.g_searchParam.startDate, val);
    },
    reWriteQueryDate(checkinDate, checkoutDate) {
      var searchParam = this.g_searchParam;
      searchParam.startDate = checkinDate;
      searchParam.endDate = checkoutDate;
      this.setG_searchParam(searchParam);
      this.getRoomList();
    },
    serviceIcon: service.serviceIcon,
    //按卡类型和房间类型计算折扣
    discount(isSp) {
      if (this.loginState == false) {
        return 1;
      }
      if (isSp) {
        return 1;
      }
      for (var index in this.cards) {
        let card = this.cards[index];
        if (
          this.g_UserInfo.Card_Kind_Diplay == "数字卡" &&
          card.ic_kindname == "网上数字卡"
        ) {
          return card.ic_kindzk;
        }
        if (
          this.g_UserInfo.Card_Kind_Diplay == "金卡" &&
          card.ic_kindname == "联名金卡"
        ) {
          return card.ic_kindzk;
        }
        if (card.ic_kindname == this.g_UserInfo.Card_Kind_Diplay) {
          return card.ic_kindzk;
        }
      }
      return 1;
    },
    commenPrice(room) {
      var discount = this.discount(false);
      return Math.round(room.MarketPrice * discount);
    },
    markPrice(price) {
      return Math.round(price);
    },
    activityPrice(room, activity) {
      if (activity.UseDiscount) {
        var res = activity.Discount * room.MarketPrice;
        //console.log(Math.round(res));
        return Math.round(res);
      } else {
        //return activity.Price;
        if (
          activity.ActivityCode == "C0000001" ||
          activity.ActivityCode == "C0000075" ||
          activity.ActivityCode == "C0000187"
        ) {
          return activity.Price.toFixed(1);
        }
        //console.log(Math.round(activity.Price));
        return Math.round(activity.Price);
      }
    },
    //获取用户上次签入时间
    getMemberLastCheckInDate() {
      var params = new this.URLSearchParam();
      params.append("hotelCode", this.g_currentInfo.HotelCode);
      this.$http
        .post(api.getMemberLastCheckInDate(), params.toParam())
        .then(res => {
          if (res.Result && (res.Data == "" || res.Data == null)) {
            this.hasCheckedIn = false;
          } else {
            this.hasCheckedIn = true;
          }
        });
    }
  },
  computed: {
    ...mapGetters(["g_currentInfo", "g_searchParam", "g_UserInfo"]),
    //当前市场价
    currentMarketPrice() {
      if (this.currentActivity == null) {
        //普通房
        return this.current.MarketPrice;
      } else if (this.currentActivity.UseDiscount) {
        //特惠折扣
        return this.current.MarketPrice * this.currentActivity.Discount;
      } else {
        //特惠定额
        return this.currentActivity.Price;
      }
    },
    //当前最低价
    currentLowestPrice() {
      if (this.currentActivity == null) {
        //非活动房使用白金卡价格
        // return this.current.PlatinumCardRate
        return this.current.PlatinumCardRate;
      } else if (this.currentActivity.UseDiscount) {
        return this.current.MarketPrice * this.currentActivity.Discount;
      } else {
        return this.currentActivity.Price;
      }
    },
    day() {
      var d1 = new Date(this.g_searchParam.startDate);
      var d2 = new Date(this.g_searchParam.endDate);
      var s1 = d1.getTime(),
        s2 = d2.getTime();

      if (this.g_searchParam.isZeroRoom) {
        return parseInt((s2 - s1) / 1000 / (24 * 60 * 60)) + 1;
      }

      return parseInt((s2 - s1) / 1000 / (24 * 60 * 60));
    },
    checkInDateFormat() {
         if(this.$route.query.checkInDate!=undefined){
            this.g_searchParam.startDate =this.$route.query.checkInDate;
         }
      return new Date(this.g_searchParam.startDate).Format("M月D日");
    },
    checkOutDateFormat() {
       if(this.$route.query.checkInDate!=undefined){
            this.g_searchParam.endDate =this.$route.query.checkOutDate;
         }
      return new Date(this.g_searchParam.endDate).Format("M月D日");
    },
    checkinMinDate() {
      //最小入住日期为当天
      return new Date();
    },
    checkinMaxDate() {
      //最大入住日期为3个月内
      return new Date().DateAdd("d", 89); //入住日期最大为3个月内
    },
    checkoutMinDate() {
      //最小离店日期比当前入住时间多一天
      return new Date(this.g_searchParam.startDate).DateAdd("d", 1);
    },
    checkoutMaxDate() {
      //最大离店日期比当前入住时间多14天
      return new Date(this.g_searchParam.startDate).DateAdd("d", 14);
    }
  }
};
</script>




<style lang="less">
@import "../../assets/theme.less";
.dateArea {
  .date {
    top: -2px;
    text-align: center;
    width: 100% !important;
    .mu-text-field {
      width: 100%;
      .mu-text-field-content {
        padding: 0px;
        width: 100%;
      }
      input {
        color: transparent;
        z-index: 101;
      }
    }
    .mu-text-field-input {
      left: 0rem;
      width: 100%;
      text-align: center;
    }
  }
  .left,
  .right {
    text-align: center;
  }
}

.orange {
  color: @primaryOrange;
}

.noRoom {
  a,
  .listTitle,
  span {
    color: #cccccc;
  }
  a {
    background-color: #eeeeee !important;
  }
}

.firstChild:before {
  content: "";
  width: 24px;
  height: 12px;
  display: block;
  background-color: #fcf6e9;
  position: absolute;
  top: -12px;
  left: 20px;
  background: linear-gradient(135deg, transparent 8.5px, #fcf6e9 0) left,
    linear-gradient(-135deg, transparent 8.5px, #fcf6e9 0) right;
  background-size: 12px 12px;
  background-repeat: no-repeat;
}

.paper {
  .mu-list {
    padding-top: 0px;
    width: 7.18rem;
    margin: auto;
    .listTitle {
      color: @secondBlack;
      font-size: 0.27rem;
      margin-top: 0px;
      position: relative;
    }
    .isChild {
      background-color: #fcf6e9 !important;
      background-position: 10px 0;
      position: relative;
      .listTitle {
        font-size: 0.25rem;
        padding-left: 0.2rem;
      }
    }
    .color {
      font-size: 0.2rem;
      padding: 2px 4px 2px 3px;
      color: white;
      border-radius: 3px;
      margin-right: 3px;
    }
    .is10 {
      background-color: #ffb03b;
    }
    .is20 {
      background-color: #ff8f3b;
    }
    .is30 {
      background-color: #b5d054;
    }
    .isKCoin {
      background-color: #ffc957;
    }
    .mu-item-wrapper {
      border-bottom: 0.02rem solid #f1f1f1;
      .show-right {
        right: 0px;
      }
    }
    .mu-item-content {
      width: 4.5rem;
    }
    .mu-item-right {
      width: auto;
      font-size: 0.24rem;
      color: @textColor;
      .money {
        display: inline-block;
        width: 4em;
        text-align: right;
        color: @primaryOrange;
        font-size: 0.32rem;
        margin: 0;
        padding-right: 5px;
      }
      a {
        color: white;
        padding: 5px 10px;
        background-color: #27ba69;
        font-size: 0.28rem;
        border-radius: 4px;
        margin: 0;
      }
      .invalid {
        color: #cccccc;
        background-color: #eeeeee;
      }
    }
  }
}

.top {
  padding: 0px;
  .mu-text-field-input {
    width: 2rem;
    color: @secondBlack;
    font-size: 0.28rem;
    height: 18px;
    top: 8px;
    left: -0.29rem;
  }
}
</style>

<style lang="less" scoped>
@import "../../assets/theme.less";

.xiaotubiao {
  margin-top: 0.05rem;
  float: left;
  img {
    height: 0.24rem;
    margin-right: 0.05rem;
  }
}

.topShade {
  background: url("../../../static/search/roomTopBg.png");
  position: absolute;
  top: 0px;
  z-index: 99;
  width: 7.5rem;
  height: 40px;
}

.paper {
  text-align: left;
  .top {
    text-align: center;
    margin-top: 10px;
    width: 100%;
    height: 1.21rem;
    display: flex;
    display: -webkit-flex;
    margin-bottom: 0rem;
    div {
      width: 33%;
      display: inline-block;
      margin: auto;
      color: @secondBlack;
      font-size: 0.28rem;
      small {
        font-size: 0.22rem;
        color: @textColor;
        position: relative;
        top: 0.2rem;
      }
    }
    .middle {
      span {
        color: @primaryOrange;
      }
    }
  }
}

.slider {
  position: absolute;
  top: 0px;
  z-index: -1;
  img {
    width: 7.5rem;
    width: 100%;
    overflow: hidden;
  }
}

.main {
  width: 7.5rem;
  background-color: #f0f0f0;
  position: absolute;
  top: 4.5rem;
  text-align: center;
}

.topBlock {
  text-align: left;
  .title {
    color: @secondBlack;
    font-size: 0.3rem;
    display: inline-block;
    font-weight: 600;
  }
  .rightArr {
    font-size: 18px;
    color: @textColor;
    font-weight: 100;
  }
  p {
    text-align: left;
    width: 100%;
    margin: 0.14rem 0 0 0;
    font-size: 0.22rem;
    .score {
      color: @primaryOrange;
      font-size: 0.42rem;
    }
    .unit {
      color: @secondBlack;
    }
    .stars {
      margin: 0 5px 0 20px;
    }
    .commont {
      margin-left: 15px;
      color: @textColor;
      font-size: 0.22rem;
    }
  }
}

.WhiteKuang1 {
  margin-left: 3%;
  width: 94%;
  max-width: 480px;
  background-color: white;
  border-radius: 5px;
  z-index: 999999;
  position: absolute;
  top: 3%;
  font-size: 90%;
  transform-origin: 0px 0px 0px;
  opacity: 1;
  transform: scale(1, 1);
}

.roomDetail {
  width: 100%;
  height: auto;

  .attrs {
    list-style: none;
    color: @secondBlack;
    font-size: 0.26rem;
    // height: 3.5rem;
    height: auto;
    overflow: auto;
    margin-top: 0px;
    padding: 0.2rem 0;
    li {
      height: 0.45rem;
    }
    label {
      color: @primaryBlack;
      text-align: left;
      width: 5.5em;
      margin-right: 0px;
    }
  }
}

.tabBottom {
  height: auto;
  display: flex;
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  padding-top: 8px;
  display: flex;
  .left {
    width: 5.8rem;
    padding: 0 0 0 0.3rem;
    font-size: 0.26rem;
    color: @primaryBlack;
    .cardsPay {
      display: flex;
      flex-wrap: wrap;
      .card {
        color: @secondBlack;
        font-size: 0.22rem;
        margin-right: 1em;
      }
    }
    .price {
      color: @primaryOrange;
      font-size: 0.32rem;
    }
    .del {
      text-decoration: line-through;
    }
  }
  .right {
    width: 1.3rem;
    margin: auto 0;
    text-align: center;
    a {
      color: white;
      background-color: @primaryColor;
      padding: 5px 10px;
      border-radius: 4px;
    }
    .invalid {
      color: #cccccc;
      background-color: #eeeeee;
    }
  }
}

.mu-dialog {
  .appDialog {
    color: #666666;
    font-size: 0.3rem;
    .img {
      margin: 1em;
      text-align: center;
      img {
        width: 3rem;
        height: 3rem;
      }
    }
    .tail {
      text-align: center;
      color: #999999;
      font-size: 0.22rem;
    }
  }
}

.appActions {
  min-height: 0;
}

.activityRemark {
  font-size: 0.22rem;
  margin-left: 0.2rem;
}

.mu-content-block {
  height: auto;

  margin-bottom: 0.05rem;

  .attrs {
    height: 4rem;
  }
}
</style>






// WEBPACK FOOTER //
// homeList.vue?53fcbd63